/* eslint import/no-unresolved: "off" */
import React from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../store/configureStore';
import { BackHyperLink, BackLinkText, BackLinkArrow } from './BackLink.styles';
import { PAID_OFF_LOAN_STATE, Routes } from '../../../constants';
import LeftCaretIcon from '../../../assets/LeftCaretIcon';
import { useDualEventTracking } from '../../../utils/useDualEventTracking';

const BackLink = (props: {
  backLinkText: string;
  backLinkRoute: string;
  backLinkTrackEvent: string;
}) => {
  const { id }: any = useParams();
  const history = useHistory();
  const { pathname } = useLocation();

  const { backLinkText, backLinkRoute, backLinkTrackEvent } = props;
  const { trackEvent } = useDualEventTracking();

  // Retrieve vehicle make from myCars state
  const myCars = useSelector((state: RootState) => state.myCars.cars);

  const selectedCarDetails = myCars.find(
    (carItem: any) => carItem.vehicle.vehicleId === Number(id)
  );

  // Local navigation from other pages to loan details
  const routeBack = () => {
    trackEvent(backLinkTrackEvent);
    history.push(backLinkRoute);
  };

  const defaultBackLink = (
    <BackHyperLink onClick={routeBack}>
      <BackLinkText>
        <BackLinkArrow>
          <LeftCaretIcon />
        </BackLinkArrow>
        {backLinkText}
      </BackLinkText>
    </BackHyperLink>
  );

  // Redirect to My Carvana URL
  // Get vehicle make from state for back to text. eg. Back To My BMW
  const {
    vehicle: { make: vehicleMake },
    loanDetails: { loanState },
  } = selectedCarDetails;

  const myCarvanaLinkText = `Back to My ${vehicleMake}`;
  const myCarvanaLinkRoute = `${Routes.MY_CARVANA_ROUTE}${id}?referenceType=vehicle`;

  const routeBackToMyCarvana = () => {
    trackEvent(backLinkTrackEvent);
    window.location.href = myCarvanaLinkRoute;
  };

  const myCarvanaBackLink = (
    <BackHyperLink onClick={routeBackToMyCarvana}>
      <BackLinkText>
        <BackLinkArrow>
          <LeftCaretIcon />
        </BackLinkArrow>
        {myCarvanaLinkText}
      </BackLinkText>
    </BackHyperLink>
  );

  /** Redirect to My Carvana OVP page if the car is paidOff and the current
   * url is transaction history */

  // Support local navigation from other pages to loan details (e.g make payment)
  let isBackToMyCarvanaLink = false;

  // Test if it's loan details page and enable back to My Carvana OVP
  const loanDetailsRegex = new RegExp(/\/loan-detail\/\d+$/gi);

  if (loanDetailsRegex.test(pathname)) {
    isBackToMyCarvanaLink = true;
  }

  /** Test if it's a transaction history page and is a paid off state to
   * enable back to My Carvana */
  if (
    pathname.indexOf(Routes.TRANSACTION_HISTORY) > -1 &&
    loanState.toLowerCase() === PAID_OFF_LOAN_STATE.toLowerCase()
  ) {
    isBackToMyCarvanaLink = true;
  }

  return <>{isBackToMyCarvanaLink ? myCarvanaBackLink : defaultBackLink}</>;
};

export default BackLink;
